

const Supheader = () => {
    return (
        <div>
            <h2>Play video message</h2>
        </div>
    )
}

export default Supheader
